module.exports = "../../../../platform/assets/pageMainIcon/nodata.png";